<template>
    <z-content
        v-if="selectedRelease">
        <div class="h-box w-100 space-between border-bottom">
            <h3>Release name: {{ selectedRelease.ReleaseDate }}</h3>

            <div class="h-box">
                <h5 v-if="roles">Viewing as: {{ roles.join(', ') }}  &nbsp;</h5>
                <a
                    href="javascript:void(0)"
                    @click="close()"
                >
                    <i class="material-icons">clear</i>
                </a>
            </div>
        </div>
        <div class="table">
            <table>
                <tr>
                    <td colspan="2">
                        <strong>GIT commit:</strong>   {{ selectedRelease.GitCommit }}
                        &nbsp;
                        <a
                            href="javascript:void(0)"
                            title="Copy to clipboard"
                            @click="copyCommitId(selectedRelease.GitCommit)"
                        >
                            <i 
                                style="font-size: 1.2em; vertical-align: middle;"
                                class="material-icons">content_copy</i>
                        </a>
                    </td>
                </tr>
                <tr>
                    <td>
                        <strong>Latest DB Change:</strong>
                        <code>
                            {{ selectedRelease.LatestDbChange }}
                        </code>
                    </td>
                    <td>
                        <span
                            v-if="selectedRelease.Tested"
                        >
                            Marked as tested
                        </span>

                        <button
                            v-else
                            @click="test()"
                        >
                            Mark as tested
                        </button>
                    </td>
                </tr>
            </table>
        </div>
        <h3>Available environments</h3>
        <div 
            v-if="environments"
            class="table table--release">
            <table>
                <thead>
                    <tr>
                        <th>Environment</th>
                        <th>Region, Type</th>
                        <th>Livestack</th>
                        <th>Deployed release</th>
                        <th>Ongoing release</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>

                    <tr
                        v-for="(environment, idx) in environments"
                        :key="idx"
                        :class="{
                            'environment--inprogress': environment.DeploymentInProgress
                        }"
                    >
                        <td>
                            <strong>{{ environment.Environment }}</strong> 
                            <code v-if="environment.ABStatus">({{ environment.ABStatus }})</code>
                        </td>
                        <td>
                            <strong>{{ environment.Region }}</strong>
                            <span
                                :class="{'badge--danger': environment.Type == 'test', 'badge--success': environment.Type == 'prod' }"
                                class="badge"
                            >
                                {{ environment.Type }}
                            </span>
                        </td>
                        <td>
                            {{ environment.LiveStack }}
                        </td>
                        <td>
                            <code>
                                {{ environment.ReleaseDate }}
                            </code>
                        </td>
                        <td>
                            <code>
                                {{ environment.OngoingReleaseDate }}
                            </code>
                        </td>
                        <td>

                            <z-actions 
                                :environment="environment"/>

                            <span
                                v-if="environment.DeploymentInProgress"
                                class="inprogress"
                            >
                                <i class="material-icons">cached</i>
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </z-content>
</template>

<script>
import { mapGetters } from 'vuex';

import Swal from 'sweetalert2';
import {EventBus} from '@/utils/eventBus';
import { copyToClipboard } from '@/utils/helpers';


export default {
    name: 'z-release',
    data () {
        return {
            intervalCheck: null,
            loaded: false,
        };
    },

    computed: {
        ...mapGetters([
            'selectedRelease',
            'environments',
            'roles'
        ])
    },

    watch: {

    },

    mounted() {
        this.intervalCheck = setInterval(() => {
            if(this.selectedRelease) {
                this.$store.dispatch('fetchEnvironments');
            }
        }, 5000); //5 seconds
    },

    methods: {

        close() {
            this.$store.dispatch('closeRelease');
        },

        async test() {

            const result = await Swal.fire({
                title: 'Testing',
                showConfirmButton: true,
                showCancelButton: true,
                text: `Are you sure want to mark ${this.selectedRelease.ReleaseDate} as tested?`,
                confirmButtonText: 'OK',
            });
            if(result.isConfirmed) {
                try {
                    const params = {
                        ReleaseDate: this.selectedRelease.ReleaseDate,
                        Action: 'markAsTested'
                    };
                    const result = await this.$http.post('/deployment/release_action', params);
                    Swal.fire({
                        title: 'Test result',
                        text: result.data.message,
                        confirmButtonText: 'OK'
                    });
                    EventBus.emit('releasecheck');
                } catch (e) {
                    Swal.fire({
                        title: 'Testing',
                        type: 'warning',
                        text: `Unable to mark ${this.selectedRelease.ReleaseDate} as tested!`,
                        confirmButtonText: 'OK',
                    });
                }
            }

        },

        async copyCommitId(text) {
            try {
                await copyToClipboard(text);
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    type: 'success',
                    title: 'Copied to clipboard'
                });
            } catch (e) {
                console.error(e);
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    type: 'error',
                    title: 'Failed to copy'
                });
            }
        }
        
    }
};
</script>
